<template>
  <a-layout width="100%" style="min-width: 190px">
    <a-layout-content>
      <a-select
        :mode="field.mode == 'default' ? null : field.mode"
        v-model:value="modalRef.selectedRows"
        :show-search="field.show_search == undefined ? true : field.show_search"
        :disabled="field.disabled"
        :placeholder="field.placeholder"
        :dropdownMatchSelectWidth="field.dropdownMatchSelectWidth"
        :default-value="field.defaultValue"
        :maxTagCount="field.maxTagCount"
        @change="handleChange"
        size="small"
        :allow-clear="field.allowClear"
        :filter-option="filterOption"
      >
        <a-select-option v-for="option in datasource" :key="option.value" :value="option.value">
          {{ option.label }}
        </a-select-option>
      </a-select>
    </a-layout-content>
    <a-layout-sider width="30px" style="background: rgba(0, 0, 0, 0)">
      <a-button size="small" style="width: 30px" @click="btnClick" type="text">
        <template #icon>
          <reload-outlined />
        </template>
      </a-button>
    </a-layout-sider>
  </a-layout>
</template>

<script lang="ts">
import { defineComponent, reactive, watch, onMounted, computed, PropType } from 'vue';
import { RequestData } from '@/utils/hooks/useFetchData';
import getFormConfig from '@/components/FormRender/RemoteSelect/index';
import { message } from 'ant-design-vue';

type Field = {
  mode: 'multiple' | 'tags' | 'combobox' | 'default';
  modalType: string;
  cb?: any;
  select_style: any;
  default: string;
  name: string;
};

export default defineComponent({
  name: 'RemoteSelect',
  props: {
    field: {
      type: Object as PropType<Field>,
      required: true,
    },
    valueKey: {
      type: String,
    },
    labelKey: {
      type: String,
    },
    labelSpace: {
      type: String,
      default: '-',
    },
    labelKeyList: {
      type: Array,
    },
    value: {
      type: [Array, Number, String],
      required: false,
      default: () => null,
    },
    label: {
      type: [Array, String],
      required: false,
      default: () => [],
    },
    formModel: {
      type: Object,
      required: true,
    },
    init_model: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:value', 'update:label'],
  setup(props, { emit }) {
    const modalRef = reactive({
      selectedRows: new Array<number | any>(),
      datasource: new Array<any>(),
    });
    const { searchConfig, getData } = getFormConfig(props.field.modalType);
    const search_modelRef = reactive({
      ...searchConfig.model,
      ...props.init_model,
    });
    if (searchConfig.model.pageSize == undefined) {
      search_modelRef.pageSize = 2000;
    }
    const old_obj: { [key: string]: any } = {};
    // const button_style = computed(() => {
    //   return props.field.cb ? 'width: 14%;min-width:30px;' : 'width: 100%;min-width:30px;';
    // });
    // const select_style = computed(() => {
    //   return 'width:80%; min-width: calc(100%-35px);';
    // });

    const get_value_key = () => {
      return props.valueKey ? (props.valueKey as string) : 'id';
    };
    const get_label_key = () => {
      return props.labelKey ? (props.labelKey as string) : 'name';
    };
    const datasource = computed(() => {
      return modalRef.datasource.map(item => {
        if (props.labelKeyList) {
          let label = [];
          for (let key of props.labelKeyList) {
            label.push(item[key as string]);
          }
          return {
            value: item[get_value_key()],
            label: label.join(props.labelSpace),
          };
        } else {
          return {
            value: item[get_value_key()],
            label: item[get_label_key()],
          };
        }
      });
    });
    const getDefaultValue = (list: any) => {
      if (
        props.field.default &&
        !props.formModel[props.field.name] &&
        props.field.mode == 'default' &&
        list.length > 0
      ) {
        props.formModel[props.field.name] = list[0][get_value_key()];
        emit('update:label', list[0][get_label_key()]);
        // modalRef.selectedRows.length = 0;
        // modalRef.selectedRows.push(list[0][get_value_key()]);
      }
      if (props.field.mode == 'default') {
        const selectItems: any = datasource.value
          .filter((item: any) => modalRef.selectedRows == item.value)
          .map((item: any) => item.label);
        emit('update:label', selectItems.length > 0 ? selectItems[0] : '');
      } else {
        emit(
          'update:label',
          datasource.value
            .filter((item: any) => modalRef.selectedRows.includes(item.value))
            .map((item: any) => item.label),
        );
      }
    };

    const check_params_need_request = () => {
      let is_ok = true;
      if (searchConfig.watch) {
        for (let k of searchConfig.watch) {
          if (props.formModel) {
            if (
              (props.formModel[k] === null || props.formModel[k] === undefined) &&
              props.init_model &&
              (props.init_model[k] === null || props.init_model[k] === undefined)
            ) {
              is_ok = false;
            }
          }
        }
      }
      return is_ok;
    };
    watch(
      () => props.formModel[props.field.name],
      () => {
        if (props.field.mode === 'default') {
          if (props.formModel[props.field.name]) {
            modalRef.selectedRows = [props.formModel[props.field.name]];
          } else {
            modalRef.selectedRows = [];
          }
        } else {
          //modalRef.selectedRows.length = 0;
          if (props.formModel[props.field.name] && props.formModel[props.field.name].length > 0) {
            modalRef.selectedRows = props.formModel[props.field.name].map((item: any) => {
              return item;
            });
          }
        }
        emit(
          'update:label',
          datasource.value
            .filter((item: any) => modalRef.selectedRows.includes(item.value))
            .map((item: any) => item.label),
        );
      },
    );

    onMounted(() => {
      let is_use = false;
      if (searchConfig.watch) {
        for (let k of searchConfig.watch) {
          if (props.formModel) {
            old_obj[k] = props.formModel[k];
          }
        }
      }
      if (searchConfig.watch && props.formModel) {
        for (let k of searchConfig.watch) {
          search_modelRef[k] = props.formModel[k];
          watch(
            () => props.formModel[k],
            () => {
              let change = false;
              if (searchConfig.watch && props.formModel) {
                for (let k of searchConfig.watch) {
                  if (old_obj[k] != props.formModel[k] && props.formModel[k]) {
                    change = true;
                    search_modelRef[k] = props.formModel[k];
                  }
                }
              }
              if (change && check_params_need_request()) {
                getData({ ...search_modelRef }).then(function (res: RequestData<any>) {
                  modalRef.datasource = res.data;
                  getDefaultValue(res.data);
                });
              }
            },
            { immediate: true },
          );
        }
      }
      if (searchConfig.attr_use && searchConfig.attr_use.length > 0) {
        for (let k of searchConfig.attr_use) {
          if (props.formModel && props.formModel[k]) {
            is_use = true;
          } else {
            is_use = false;
            break;
          }
        }
      } else {
        if (check_params_need_request()) {
          getData({ ...search_modelRef }).then(function (res: RequestData<any>) {
            modalRef.datasource = res.data;
            getDefaultValue(res.data);
          });
        }
      }
      if (is_use && check_params_need_request()) {
        getData({ ...search_modelRef }).then(function (res: RequestData<any>) {
          modalRef.datasource = res.data;
          getDefaultValue(res.data);
        });
      }
    });

    if (props.field.mode === 'default') {
      if (props.value) {
        if (isNaN(Number(props.value))) {
          modalRef.selectedRows.push(props.value);
        } else {
          modalRef.selectedRows.push(Number(props.value));
        }
      }
    } else {
      if (typeof props.value == 'string') {
        (props.value as string).split(',').map((item: any) => {
          modalRef.selectedRows.push(Number(item));
        });
      } else if (props.value instanceof Array) {
        props.value.map((item: any) => {
          if (isNaN(Number(item))) {
            modalRef.selectedRows.push(item);
          } else {
            modalRef.selectedRows.push(Number(item));
          }
        });
      } else if (props.value != null) {
        modalRef.selectedRows.push(props.value);
      }
    }
    const btnClick = () => {
      message.loading({ content: '刷新数据……', key: props.field.modalType });
      getData({ ...search_modelRef }, true)
        .then(function (res: RequestData<any>) {
          modalRef.datasource = res.data;
          getDefaultValue(res.data);
          message.success({ content: '刷新数据成功', key: props.field.modalType, duration: 2 });
        })
        .catch(() => {
          message.destroy();
          message.error('接口调用失败', 10);
        });
    };

    const handleChange = () => {
      if (props.field.mode == 'default') {
        emit('update:value', modalRef.selectedRows);
        const selectItems: any = datasource.value
          .filter((item: any) => {
            return modalRef.selectedRows == item.value;
          })
          .map((item: any) => item.label);
        emit('update:label', selectItems.length > 0 ? selectItems[0] : '');
      } else {
        if (modalRef.selectedRows.length > 1) {
          emit('update:value', modalRef.selectedRows);
        } else {
          emit('update:value', modalRef.selectedRows);
        }
        emit(
          'update:label',
          datasource.value
            .filter((item: any) => modalRef.selectedRows.includes(item.value))
            .map((item: any) => item.label),
        );
      }
    };
    const filterOption = (val: string, option: any) => {
      if (datasource.value instanceof Array) {
        let f: any = datasource.value.find(item => {
          return item['value'] == option.key;
        });
        if (f) {
          return f['label'].toLowerCase().indexOf(val.toLowerCase()) >= 0;
        } else {
          return false;
        }
      }
    };

    return {
      props,
      modalRef,
      search_modelRef,
      searchConfig,
      handleChange,
      filterOption,
      datasource,
      btnClick,
    };
  },

  data() {
    return {
      model: this.value,
    };
  },
  components: {},
});
</script>
